<template>
  <Modal
    title="在线预览"
    v-model="dialogVisible"
    width="950px"
    :mask-closable="false"
    @on-cancel="handleClose"
  >
    <div class="video-preview-container">
      <div class="video-section">
        <div class="video-player">
          <video
            ref="videoRef"
            :src="videoUrl"
            class="video"
            @timeupdate="handleTimeUpdate"
            @loadedmetadata="handleLoadedMetadata"
            @ended="handleVideoEnded"
            controls
          >
            您的浏览器不支持视频播放
          </video>
        </div>
      </div>

      <div class="episode-section">
        <div class="episode-header">
          <span class="episode-title">集数列表</span>
          <span class="episode-count">{{ currentEpisode }}/{{ totalEpisodes }}</span>
        </div>
        <div class="episode-grid">
          <button
            v-for="episode in totalEpisodes"
            :key="episode"
            class="episode-btn"
            :class="{ active: currentEpisode === episode }"
            @click="selectEpisode(episode)"
          >
            {{ episode }}
          </button>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
export default {
  name: 'VideoPreview',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      videoRef: null,
      isPlaying: false,
      currentTime: 0,
      duration: 0,
      currentEpisode: 1,
      isSeeking: false
    }
  },
  computed: {
    totalEpisodes() {
      if (this.row.episodeCount) {
        const match = this.row.episodeCount.match(/\/(\d+)/)
        return match ? parseInt(match[1]) : 16
      }
      return 16
    },
    videoUrl() {
      return 'https://www.w3schools.com/html/mov_bbb.mp4'
    },
    progressPercent() {
      if (this.duration === 0) return 0
      return (this.currentTime / this.duration) * 100
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.dialogVisible = newVal
      }
    },
    dialogVisible(newVal) {
      if (newVal) {
        this.currentEpisode = 1
      }
    }
  },
  beforeDestroy() {
    const video = this.$refs.videoRef
    if (video) {
      video.pause()
    }
  },
  methods: {
    formatTime(seconds) {
      const mins = Math.floor(seconds / 60)
      const secs = Math.floor(seconds % 60)
      return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
    },
    togglePlay() {
      const video = this.$refs.videoRef
      if (video) {
        if (this.isPlaying) {
          video.pause()
        } else {
          video.play()
        }
        this.isPlaying = !this.isPlaying
      }
    },
    handleTimeUpdate() {
      const video = this.$refs.videoRef
      if (video) {
        this.currentTime = video.currentTime
      }
    },
    handleLoadedMetadata() {
      const video = this.$refs.videoRef
      if (video) {
        this.duration = video.duration
      }
    },
    handleVideoEnded() {
      this.isPlaying = false
    },
    selectEpisode(episode) {
      this.currentEpisode = episode
      const video = this.$refs.videoRef
      if (video) {
        video.currentTime = 0
        video.pause()
        this.isPlaying = false
      }
    },
    handleClose() {
      const video = this.$refs.videoRef
      if (video) {
        video.pause()
        video.currentTime = 0
      }
      this.isPlaying = false
      this.currentTime = 0
      this.currentEpisode = 1
      this.$emit('update:visible', false)
    this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
.video-preview-container {
  display: flex;
  gap: 20px;
  padding: 10px;
  height: 500px;
}

.video-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: #000;
  border-radius: 8px;
  overflow: hidden;
}

.video-player {
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #000;
}

.video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.play-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.3);
  cursor: pointer;
  z-index: 10;
}

.episode-section {
  width: 240px;
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
}

.episode-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e4e7ed;
}

.episode-title {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
}

.episode-count {
  font-size: 12px;
  color: #606266;
}

.episode-grid {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  overflow-y: auto;
}

.episode-btn {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 8px;
  background-color: #fff;
  color: #606266;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: #e6f7ff;
    color: #1890ff;
  }

  &.active {
    background-color: #409eff;
    color: #fff;
  }
}
</style>
